import { useQuery } from "@tanstack/react-query";
import { useGetList } from "ra-core";

import { getSupabaseClient } from "../../providers/supabase/supabase";
import {
  STATS_NUMBERS,
  type CallLogRow,
  type Period,
  type SetterStats,
} from "./setterStats";

/** Numbers of every seller for the period (admins only; the database checks). */
export const useSetterStats = (period: Period) =>
  useQuery({
    queryKey: ["gula_setter_stats", period.from, period.to],
    refetchInterval: 60_000,
    queryFn: async (): Promise<SetterStats[]> => {
      const { data, error } = await getSupabaseClient().rpc(
        "gula_setter_stats",
        { p_from: period.from, p_to: period.to },
      );
      if (error) throw new Error(error.message);
      return ((data ?? []) as Record<string, unknown>[]).map((row) => {
        const numbers = Object.fromEntries(
          STATS_NUMBERS.map((key) => [key, Number(row[key] ?? 0)]),
        );
        return {
          ...row,
          ...numbers,
          avg_first_call_hours:
            row.avg_first_call_hours == null
              ? null
              : Number(row.avg_first_call_hours),
        } as unknown as SetterStats;
      });
    },
  });

/** Every logged call of one person in the period, newest first. */
export const useSetterLog = (salesId: string | null, period: Period) =>
  useGetList<CallLogRow>(
    "gula_call_log_detail",
    {
      filter: {
        sales_id: salesId ?? -1,
        "day@gte": period.from,
        "day@lte": period.to,
      },
      pagination: { page: 1, perPage: 2000 },
      sort: { field: "created_at", order: "DESC" },
    },
    { enabled: salesId != null },
  );
